import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import 'fontsource-roboto';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

// utils
import configureStore, { ReactReduxContext } from './config/configureStore';

// components
import App from './App';

// styles
import './commons/assets/styles.scss';

// init sentry
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_KEY,
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: process.env.REACT_APP_TRACES_SAMPLE_RATE || 0.1,
});

const store = configureStore();
const persistor = persistStore(store);

const renderApp = () =>
  render(
    <Provider store={store} context={ReactReduxContext}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App context={ReactReduxContext} />
        </BrowserRouter>
      </PersistGate>
    </Provider>,
    document.querySelector('#root'),
  );

renderApp();

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    // Support hot reloading of components
    // and display an overlay for runtime errors
    module.hot.accept('./App', () => {
      renderApp();
    });
  }
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js');
  });
} else {
  console.log('serviceWorker not available');
}
